module.exports = {
    Globals: {
        AccessTokenKey: 'accessToken',
        AccessTokenExpiry: 'accessTokenExpiry'
    },
    RouteNames: {
        Templates: {
            FieldTemplateIndex: 'report-field-template-index',
            FieldTemplateEdit: 'report-field-template-edit'
        },
        Reports: {
            ReportIndex: 'report-index',
            ReportEdit: 'report-edit',
            ReportEditHome: 'report-edit-home',
            ReportEditSection: 'report-edit-section'
        }
    }
}